import { CellGlobalActions } from '@components/organisms/Datatable/cells/CellGlobalActions';

const tableSchemaBase = [
	{
		accessor: 'name',
		title: 'global.name',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'organization',
		title: 'global.organization',
		sortable: true,
		defaultVisible: true,
		fixed: true,
	},
	{
		accessor: 'contactName',
		title: 'global.contactName',
		sortable: false,
		defaultVisible: true,
	},
	{
		accessor: 'contactEmail',
		title: 'global.contactEmail',
		sortable: false,
		defaultVisible: true,
	},
	{
		accessor: 'countryCode',
		title: 'global.country',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'obfuscateIPFS',
		title: 'global.dataOnIPFS',
		type: 'obfuscateIPFSStatus',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'place',
		title: 'global.place',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'createdAt',
		title: 'global.createdAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'verified',
		title: 'global.status',
		type: 'verifiedStatus',
		sortable: true,
		defaultVisible: true,
	},
	{
		accessor: 'updatedAt',
		title: 'global.updatedAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'legalIdentifier',
		title: 'global.legalIdentifier',
		sortable: false,
		defaultVisible: false,
	},
	{
		accessor: 'verifiedBy',
		title: 'global.verifiedBy',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'verifiedAt',
		title: 'global.verifiedAt',
		sortable: true,
		defaultVisible: false,
	},
	{
		accessor: 'contactPhone',
		title: 'global.contactPhone',
		sortable: false,
		defaultVisible: false,
	},
	{
		type: 'commonActions',
		accessor: 'actions',
		title: <CellGlobalActions />,
		width: 50,
		resizable: true,
		defaultVisible: true,
	},
];

export { tableSchemaBase };
